<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">관리자 관리</h2>
        <div class="admin-manage-btn-top">
            <button type="button" class="sysadmin-default-btn" @click="showModal=true">생성</button>
        </div>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>그룹관리</caption>
              <colgroup>
                <col style="width:10%">
                <col style="width:30%">
                <col style="width:20%">
                <col style="width:30%">
                <col style="width:10%">
              </colgroup>
              <tr>
                <th>ID</th>
                <th>관리자명</th>
                <th>Email</th>
                <th>소속 그룹</th>
                <th>상태</th>
              </tr>
              <tr v-for="(item, index) in this.getAdminRole" v-bind:key="index" @click="fnModify(item)">
                  <td>{{ item.loginId }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.groupName }}</td>
                  <td>{{ item.statusName }}</td>
                  <td></td>
              </tr>
            </table>
          </div>
        </section>
        <modal v-if="showModal" @close="showModal=false">
            <h3 slot="body">
                <div class="form-modal-container">
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-userId">ID *</label>
                        <input
                            v-model.trim="userId"
                            class="default-input form-input"
                            type="text"
                            id="report-userId"
                            placeholder="ID"
                            v-bind:readonly="isReadOnly">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-userName">관리자명 *</label>
                        <input
                            v-model.trim="userName"
                            class="default-input form-input"
                            type="text"
                            id="report-userName"
                            placeholder="관리자명">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-email">Email</label>
                        <input
                            v-model.trim="email"
                            class="default-input form-input"
                            type="text"
                            id="report-email"
                            placeholder="비고">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                            <label class="form-label" for="report-status">그룹 *</label>
                            <select name="state-select" id="state-select" class="default-select" v-model="groupId">
                                <option value="" v-if="flag === 'C'">그룹 선택</option>
                                <option v-for="(type) in this.getGroupsCombo" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-modal" v-if="flag === 'U'">
                        <div class="input-area">
                            <label class="form-label" for="report-status">사용여부</label>
                            <select name="state-select" id="state-select" class="default-select" v-model="statusCode">
                                <option v-for="(type) in this.getStatuses" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-btn-area">
                    <button type="button" class="modal-btn-save" @click="save()">저장</button>
                    <button type="button" class="modal-btn-cancle" @click="cancle()">닫기</button>
                </div>
            </h3>
        </modal>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import Modal from '@/components/AdminModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminManger',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'modal': Modal
  },
  data () {
    return {
      groupId: '',
      groupName: '',
      email: '',
      id: '',
      userId: '',
      userName: '',
      statusCode: '',
      statusTitle: '',
      flag: 'C',
      showModal: false,
      isReadOnly: false
    }
  },
  created () {
    this.setInit({'method': 'GET'})
  },
  methods: {
    ...mapActions({
      setInit: 'apiSysadminUsersAdminrole'
    }),
    fnModify (item) {
      this.groupId = item.groupId
      this.groupName = item.groupName
      this.email = item.email
      this.id = item.id
      this.userId = item.loginId
      this.userName = item.name
      this.statusCode = item.statusCode
      this.statusTitle = item.statusName
      this.flag = 'U'
      this.showModal = true
      this.isReadOnly = true
    },
    save () {
      if (this.userId === '' || this.userName === '' || this.groupId === '') {
        alert('필수값을 입력해주세요.')
        return
      } else if (this.groupId === '') {
        alert('\'그룹\'을 선택해주세요.')
        return
      }
      if (this.flag === 'U') { // 수정일 경우
        const params = {
          'id': this.id,
          'email': this.email,
          'groupId': this.groupId,
          'name': this.userName,
          'status': this.statusCode,
          'method': 'PATCH'
        }
        this.$store.dispatch('apiSysadminUsersAdminrole', params)
      } else { // 생성일 경우
        const params = {
          'email': this.email,
          'groupId': this.groupId,
          'loginId': this.userId,
          'name': this.userName,
          'method': 'POST'
        }
        this.$store.dispatch('apiSysadminUsersAdminrole', params)
      }
      // this.initValues()
    },
    cancle () {
      this.initValues()
    },
    initValues () {
      this.groupId = ''
      this.groupName = ''
      this.email = ''
      this.id = ''
      this.userId = ''
      this.userName = ''
      this.statusCode = ''
      this.statusTitle = ''
      this.showModal = false
      this.flag = 'C'
      this.isReadOnly = false
    }
  },
  computed: {
    ...mapGetters(['getAdminRole', 'getStatuses', 'getGroupsCombo'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminManager.vue